import { useRoute } from 'vue-router'
import useGet from '../../../core/composables/api/useGet'
import { computed, toValue, watch, type MaybeRef } from 'vue'
import type { JSONContent } from '@tiptap/vue-3'

export const usePrepareSuperpowerSlide = (feedbackTopicId: MaybeRef<string>) => {
  const route = useRoute()
  const url = computed(() => {
    return `dialog/prepare/${route.params.id}/superpower-slide/${toValue(feedbackTopicId)}`
  })

  const { data, load, status } = useGet<DialogPrepareSuperpowerSlide>(url)

  watch(
    url,
    () => {
      load()
    },
    { immediate: true },
  )

  return { data, status }
}

export interface DialogPrepareSuperpowerSlide {
  readonly superpower?: {
    id: string
    title: string
    color: string
    image?: string
    date: string
  }
  readonly superpowerSurveyId?: string
  readonly spontaneousFeedbacks: ReadonlyArray<{
    id: string
    senderId?: string
    text: JSONContent
    date: string
  }>
  readonly slideProperties: {
    readonly spontaneousFeedbackIds: Array<string>
    readonly updatedAt: string | null
  }
}
